// quantity +/- button handler for line-item-quantity
function ygUpdateQuantityBtnState(lineItemQuantity) {
  const input = lineItemQuantity.querySelector(".quantity-input[data-line-key]");
  if (!input) return;
  const min = parseInt(input.getAttribute("min")) || 1;
  const max = input.getAttribute("max") ? parseInt(input.getAttribute("max")) : Infinity;
  const current = parseInt(input.value) || 1;
  const decreaseBtn = lineItemQuantity.querySelector(".quantity-btn[data-action='decrease']");
  const increaseBtn = lineItemQuantity.querySelector(".quantity-btn[data-action='increase']");
  if (decreaseBtn) decreaseBtn.disabled = current <= min;
  if (increaseBtn) increaseBtn.disabled = current >= max;
}

document.addEventListener("click", function (event) {
  const btn = event.target.closest(".quantity-btn[data-action]");
  if (!btn || btn.disabled) return;

  const lineItemQuantity = btn.closest("line-item-quantity");
  if (!lineItemQuantity) return;

  const input = lineItemQuantity.querySelector(".quantity-input[data-line-key]");
  if (!input) return;

  const action = btn.getAttribute("data-action");
  const step = parseInt(input.getAttribute("step")) || 1;
  const min = parseInt(input.getAttribute("min")) || 1;
  const max = input.getAttribute("max") ? parseInt(input.getAttribute("max")) : Infinity;
  let current = parseInt(input.value) || 1;

  if (action === "increase") {
    current = Math.min(current + step, max);
  } else if (action === "decrease") {
    current = Math.max(current - step, min);
  }

  input.value = current;
  input.dispatchEvent(new Event("change", { bubbles: true }));
  ygUpdateQuantityBtnState(lineItemQuantity);
});

// 初始化所有已有 line-item-quantity 的按钮状态
function ygInitAllQuantityBtns() {
  document.querySelectorAll("line-item-quantity").forEach(ygUpdateQuantityBtnState);
}

document.addEventListener("DOMContentLoaded", ygInitAllQuantityBtns);

// 购物车更新后重新初始化按钮状态
document.documentElement.addEventListener("cart:change", function () {
  setTimeout(ygInitAllQuantityBtns, 300);
});

// 监听 DOM 变化，购物车抽屉动态插入时自动初始化
var ygQuantityObserver = new MutationObserver(function (mutations) {
  mutations.forEach(function (mutation) {
    mutation.addedNodes.forEach(function (node) {
      if (node.nodeType !== 1) return;
      // 新增节点本身是 line-item-quantity
      if (node.matches && node.matches("line-item-quantity")) {
        ygUpdateQuantityBtnState(node);
      }
      // 新增节点内部包含 line-item-quantity
      if (node.querySelectorAll) {
        node.querySelectorAll("line-item-quantity").forEach(ygUpdateQuantityBtnState);
      }
    });
  });
});
ygQuantityObserver.observe(document.body, { childList: true, subtree: true });

document.addEventListener("DOMContentLoaded", function () { 
  class YGBuyItNow extends HTMLElement {
    constructor() {
      super()
      this.init()
    }
    init() {
      // 这里放置初始化逻辑
      let _this = this
      let $button = _this.querySelector('.yg-buy-it-now-button')
      $button.addEventListener('click', () => _this.buttonClick())
    }
    buttonClick() {
      // 这里放置自定义逻辑
      let buyBtn = this.querySelector('.shopify-payment-button .shopify-payment-button__more-options') || this.querySelector('.shopify-payment-button .shopify-payment-button__button');
      buyBtn.click();
    }
  }
  if (!window.customElements.get('yg-buy-it-now')) {
    window.customElements.define('yg-buy-it-now', YGBuyItNow)
  }

  class YGImageCardSwiper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    }

    init() {
      const swiperEl = this.querySelector('.yg-swiper');
      if (!swiperEl) return;

      const nextButton = this.querySelector('.swiper-button-next');
      const prevButton = this.querySelector('.swiper-button-prev');
      const pagination = this.querySelector('.swiper-pagination');
      const slidesMobile = parseFloat(this.dataset.slidesMobile || '1') || 1;
      const slidesTablet = parseFloat(this.dataset.slidesTablet || '1.6') || 1.6;
      const slidesDesktop = parseFloat(this.dataset.slidesDesktop || '2') || 2;

      this.swiper = new Swiper(swiperEl, {
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
        pagination: pagination ? {
          el: pagination,
          clickable: true,
        } : false,
        breakpoints: {
          260: {
            slidesPerView: slidesMobile,
            spaceBetween: 12,
          },
          550: {
            slidesPerView: slidesMobile,
            spaceBetween: 12,
          },
          700: {
            slidesPerView: slidesTablet,
            spaceBetween: 12,
          },
          1200: {
            slidesPerView: slidesDesktop,
            spaceBetween: 12,
          },
        },
      });
    }
  }

  if (!window.customElements.get('yg-image-card-swiper')) {
    window.customElements.define('yg-image-card-swiper', YGImageCardSwiper);
  }


  class YGAccordion extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const header = this.querySelector(".yg-accordion-header");
      const content = this.querySelector(".yg-accordion-content");
      const trueHeight = content.scrollHeight;
      content.style.setProperty("--true-height", `${trueHeight}px`);
      header.addEventListener("click", () => { 
        this.classList.toggle("yg-accordion-open");
      });
    }
  }

  if (!window.customElements.get("yg-accordion")) {
    window.customElements.define("yg-accordion", YGAccordion);
  }

});